import {Component, SimpleChanges, OnChanges, Input} from '@angular/core';
import { InfoTileComponent } from '@components/info-tile/info-tile.component';
import {PlacementService} from '@services/placement.service';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-body-weight-stats',
    standalone: true,
    imports: [InfoTileComponent],
    templateUrl: './body-weight-stats.component.html',
    styleUrl: './body-weight-stats.component.scss'
})
export class BodyWeightStatsComponent implements OnChanges {
    @Input() cycleId: number | null = null;

    bodyWeightStats: any = {
        currentAvgWeight: 0,
        previousAvgWeight: 0,
        growth: 0,
        totalBirds: 0,
        targetAchievements: 0
    };

    constructor(
        private placementService: PlacementService,
        private toastr: ToastrService
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['cycleId'] && this.cycleId) {
            this.getBodyWeightStats(this.cycleId);
        }
    }

    getBodyWeightStats(placementId: number): void {
        this.placementService.getBodyWeightMetrics(placementId).subscribe({
            next: (response) => {
                this.bodyWeightStats = response;
            },
            error() {}
        });
    }
}
